<template>
    <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  margin: 0px;
  padding: 0px;
  border: 0px;
}
html, body {
  margin: 0px;
  padding: 0px;
  border: 0px;
  background: #101010;
}
.full-screen {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.page-wrap {
  position: relative;
}
.top-click {
  position: absolute;
  top: 0;
  left: 0;
  width: 300px;
  height: 200px;
}
</style>